import { Box, InputLabel, Stack } from "@mui/material";
import React, { useEffect, useState } from "react";

import { QueryInput } from "components/common/QueryInput";
import { DETECTOR_QUERY_LENGTH_LIMIT } from "config/constants";
import { Typography } from "new-components/typography/Typography";

export interface CreateTextRecognitionProps {
  queryValue: string;
  handleChangeValue: (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  setHasErrors?: (hasErrors: boolean) => void;
  defaultValue?: string;
  placeholder?: string;
  hint?: string;
}

export function DetectorQueryInput({
  queryValue,
  handleChangeValue,
  setHasErrors,
  defaultValue = "",
  placeholder,
  hint,
}: CreateTextRecognitionProps) {
  const [hasValueChanged, setHasValueChanged] = useState(false);

  /**
   * Sets the default query value if there is no query value yet.
   */
  useEffect(() => {
    if (hasValueChanged || queryValue !== "") {
      return;
    }

    handleChangeValue({
      target: { value: defaultValue, name: "labelPrompt" },
    } as React.ChangeEvent<HTMLInputElement>);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasValueChanged, queryValue]);

  const exceedsLimit = queryValue.length > DETECTOR_QUERY_LENGTH_LIMIT;

  return (
    <Stack>
      <Box
        className="flex flex-col gap-2.5 w-full bg-white p-[15px]"
        sx={{ border: exceedsLimit ? "1px solid #D32F2F" : "1px solid white" }}
      >
        <InputLabel className="text-sm md:text-base text-black font-medium">QUERY:</InputLabel>
        <QueryInput
          name="labelPrompt"
          placeholder={placeholder ?? defaultValue}
          value={queryValue}
          onChange={(event) => {
            handleChangeValue(event);
            setHasValueChanged(true);

            const newQueryValue = event.target.value;
            setHasErrors?.(newQueryValue.length > DETECTOR_QUERY_LENGTH_LIMIT);
          }}
        />
      </Box>

      <Typography sx={{ marginTop: 1, textAlign: "right" }} color={exceedsLimit ? "error.main" : undefined}>
        {queryValue.length} / {DETECTOR_QUERY_LENGTH_LIMIT}
      </Typography>

      {hint && <Typography my={2}>{hint}</Typography>}
    </Stack>
  );
}
